import { Dialog, DialogContent } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import Profile from "../pages/AccountPreferences/Profile";
import Ulalive from "../pages/Ulalive/Ulalive";
import { getUserProfile } from "../store/user/user.selector";
import { IsNullOrEmpty } from "./utility";

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { userProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
        };
    });

    let accessToken = sessionStorage.getItem(process.env.REACT_APP_AUTH_TOKEN);

    const metaTag = document.querySelector(`link[id="glob-boot"]`);
    if (metaTag) {
        metaTag.remove();
    }

    if (!IsNullOrEmpty(accessToken)) {
        return (
            <Ulalive>
                {children}
                <Dialog
                    open={
                        userProfile &&
                        userProfile._id &&
                        (!userProfile.phone || !userProfile.email)
                    }
                >
                    <DialogContent>
                        <Profile isPop={true} />
                    </DialogContent>
                </Dialog>
            </Ulalive>
        );
    } else {
        return (
            <Navigate
                to={
                    "/login#" +
                    location.pathname +
                    location.search +
                    location.hash
                }
                state={{ lastPage: location.pathname }}
            />
        );
    }
};

export default ProtectedRoute;
